<template>
 <div class="wrapper">
    
  <div >
      <CRow>
     <CCol col="5" >
    <CCard>   
    <CCardHeader><b>Group Youth Info</b></CCardHeader>
      <CListGroup >
        <CListGroupItem href="#"> Group Name :  {{ datas.data.name }} </CListGroupItem>
        <CListGroupItem href="#"> Coach Name :  {{ coachname }}
        <CButton class="ml-3" variant="outline" color="info" size="sm" @click="openManageCoach(datas.data.id, datas.data.coach_id)">  Change Coach </CButton> 
        </CListGroupItem>
        <CListGroupItem href="#"> Description :  {{ datas.data.description }} </CListGroupItem>
        </CListGroup>
    </CCard>
    </CCol>
     <CCol col="7">
    <CCard>   
    <CCardHeader><b>Icare List</b> <CButton class="ml-2" size="sm" variant="outline" color="info" @click="openManageIcare(datas.data.id)">Manage iCare</CButton>
    </CCardHeader>
      <CListGroup v-for="item in datas.data.icare" :key="item.id" >
        <CListGroupItem href="#">
          {{ item.name }} 
          
        </CListGroupItem>
       </CListGroup>
    </CCard>
    </CCol>
    </CRow>
 

  <alertmodal></alertmodal>
  <managecoachmodal></managecoachmodal>
  <manageicaremodal></manageicaremodal>
    </div>
 </div>
</template>

<script>  
import _ from 'lodash'
import axios from 'axios'
import EventBus from '@/eventBus';

import group from '@/services/coachgroupyouth'
import managecoachmodal from './coach_group_manage_coach';
import manageicaremodal from './coach_group_manage_icare';

import alertmodal from '@/views/alert/modal.vue';
import store from '@/store.js'

export default {
name: 'detailmodal',
components: { alertmodal ,manageicaremodal,managecoachmodal },
  data () {
    return {
      mode: '',
      datas:[],
      icare:[],
      coachname:'',
      }
  },
 mounted (){
     this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
 methods:{
    openManageIcare: function (id) {
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
      var params = {title: 'Manage Icare', mode:'edit',data:id}
      EventBus.$emit('OPEN_MODAL_MANAGE_ICARE', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openManageCoach: function (id) {
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
      var params = {title: 'Manage Coach', mode:'edit',data:id}
      EventBus.$emit('OPEN_MODAL_MANAGE_COACH', params)
      console.log('open modal coach')
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
   load(){
     group.getGroupbyID(this.$route.query.Pud)
      .then(res => {
      this.datas =res
     
            if(res.data.coach !== null){
                this.coachname = res.data.coach.firstname + " " + res.data.coach.lastname
            }

      })
    },
    
  }  
}

</script>
